<template>
  <div class="state-selector">
    <a class="button is-small is-danger"
       :class="{ 'is-outlined': this.selected !== 1 }"
       @click="updateState(1)"
    >Rascunho</a>
    <a class="button is-small is-warning"
       :class="{ 'is-outlined': this.selected !== 2 }"
       @click="updateState(2)"
    >Pendente</a>
    <a class="button is-small is-success"
       :class="{ 'is-outlined': this.selected !== 3 }"
       @click="updateState(3)"
    >Publicado</a>
  </div>
</template>

<script>
  export default {
    props: {
      selected: Number,
      target: Object,
      update: String
    },

    data () {
      return {
      }
    },

    methods: {
      updateState (state) {
        if (this.update === 'coach') {
          this.$store.dispatch('updateCoachState', {id: this.target.id, data: {state: state}})
        }
        if (this.update === 'menu') {
          let data = {
            state: state,
            coach: this.target.coach_id,
            category: this.target.id
          }
          this.$store.dispatch('updateCategoryCoachState', {id: this.target.coach_id, data: data})
        }
        if (this.update === 'menu-slides') {
          let data = {
            state: state,
            coach: this.target.coach_id,
            category: this.target.id
          }
          this.$store.dispatch('updateMenuState', {id: this.target.coach_id, data: data})
        }
        if (this.update === 'slide') {
          let data = {
            state: state,
            coach: this.target.coach_id,
            category: this.target.slide_category_id
          }
          this.$store.dispatch('updateSlideState', {id: this.target.id, data: data})
        }
        if (this.update === 'exterior') {
          let data = {
            state: state,
            coach: this.target.coachId,
            exterior: this.target.exteriorId
          }
          this.$store.dispatch('updateExteriorState', {id: this.target.exteriorId, data: data})
        }
      }
    }
  }
</script>

<style lang="scss">
  .state-selector .button {
    border-radius: 290486px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
</style>


// WEBPACK FOOTER //
// StateSelector.vue?d92e9d48